import { Button, Stack } from "@mui/material";
import * as React from "react";
import FlagRoundedIcon from "@mui/icons-material/FlagRounded";
import ArrowUpwardOutlinedIcon from "@mui/icons-material/ArrowUpwardOutlined";
import ArrowDownwardOutlinedIcon from "@mui/icons-material/ArrowDownwardOutlined";

export interface TableCellJobPriorityProps {
  priority: number;
  onChange: (way: number) => void;
}

const TableCellJobPriority: React.FC<TableCellJobPriorityProps> = ({ priority, onChange }) => {
  let color;
  // todo : finish color choices and ranges
  //   switch (true) {
  //     case priority < 10:
  //       color = "primary";
  //       break;
  //     case 10 < priority && priority < 25:
  //       color = "primary";
  //       break;
  //     case 25 < priority && priority < 50:
  //       color = "warning";
  //       break;
  //     case 50 < priority && priority < 100:
  //       color = "error";
  //       break;
  //   }
  switch (priority) {
    case 10:
      color = "primary";
      break;
    case 25:
      color = "warning";
      break;
    case 50:
      color = "error";
      break;
    case 100:
      color = "success";
      break;
  }

  return (
    <>
      <Stack display="inline-flex" direction="row" alignItems="center">
        <Button
          size="small"
          sx={{ padding: "0" }}
          disabled={false}
          startIcon={<ArrowDownwardOutlinedIcon sx={{ mr: -0.5 }} />}
          onClick={() => onChange && onChange(-1)}
        ></Button>
        <FlagRoundedIcon color={color} />
        <Button
          size="small"
          disabled={false}
          startIcon={<ArrowUpwardOutlinedIcon sx={{ mr: -0.5 }} />}
          sx={{ padding: "0" }}
          onClick={() => onChange && onChange(1)}
        ></Button>
      </Stack>
      {/* <span>{priority}</span> */}
    </>
  );
};

export default TableCellJobPriority;
